import apiService from './api.service';
import type { UserAttributes } from '@/types/user.types';

// Define the structure for creating/updating an employee from the frontend
export interface EmployeeFormData {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  password?: string; // Optional: only for creation or password change
  status: 'active' | 'inactive';
  roleId?: string;
}

class EmployeeService {
  // Fetch all users who are employees
  async getEmployees(): Promise<UserAttributes[]> {
    const response = await apiService.get<{ data: UserAttributes[] }>('/users');
    return response.data.data;
  }

  // Create a new employee
  async createEmployee(employeeData: EmployeeFormData): Promise<UserAttributes> {
    const response = await apiService.post<{ data: UserAttributes }>('/users/employee', employeeData);
    return response.data.data;
  }

  // Update an existing employee
  async updateEmployee(id: string, employeeData: EmployeeFormData): Promise<UserAttributes> {
    const response = await apiService.put<{ data: UserAttributes }>(`/users/${id}`, employeeData);
    return response.data.data;
  }

  // Soft delete (deactivate) an employee
  async deleteEmployee(id: string): Promise<void> {
    await apiService.delete(`/users/${id}`);
  }
}

const employeeService = new EmployeeService();
export default employeeService;
